import styles from './InputContainer.module.scss';

import { useId, useMemo, type MouseEvent, type ReactNode } from 'react';
import { InputStatus } from './InputStatus';
import { InputContext, InputContextValue } from './InputContext';

export type InputAlign = 'start' | 'center' | 'end';

interface Props {
  children: ReactNode | ((args: { id: string }) => ReactNode);
  id?: string;
  label: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  status?: InputStatus;
  addon?: ReactNode;
  start?: ReactNode;
  end?: ReactNode;
  prefix?: string;
  suffix?: string;
}

export function InputContainer(props: Props) {
  const preID = useId();
  const id = props.id ?? preID;
  const addon = props.addon && (
    <div className={styles['addon']}>{props.addon}</div>
  );
  const children =
    typeof props.children === 'function'
      ? props.children({ id })
      : props.children;
  const start = props.start && <div>{props.start}</div>;
  const end = props.end && <div>{props.end}</div>;

  const contextValue = useMemo<InputContextValue>(() => ({ id }), [id]);

  return (
    <InputContext.Provider value={contextValue}>
      <div className={styles['root']} onClick={props.onClick}>
        <div className={styles['content']}>
          <div className={styles['label']}>
            <label htmlFor={id}>{props.label}</label>
          </div>
          <div className={styles['controls']}>
            {start}
            {children}
            {end}
          </div>
        </div>
        {addon}
      </div>
    </InputContext.Provider>
  );
}
